import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { APICONSTANTS } from "../../constants/api-constants";
import { NTHDestination } from "../../constants/flag";
import { SsFamilleModel } from "../../models/simple-types/ss-famille.model";
import { GenericLibelleService } from "../basic/generic-libelle.service";
import { HostnameService } from "../basic/hostname.service";

@Injectable()
export class SsFamilleService extends GenericLibelleService<SsFamilleModel> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTESSFAMILLE, hostnameService);
  }

  GetFromActivite(idActivite: number): Observable<SsFamilleModel[]> {
    // tslint:disable-next-line: max-line-length
    return this.http.get<SsFamilleModel[]>(APICONSTANTS.URLAPI.value + this.route + 'GetFromActivite?idActivite=' + idActivite)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }

  getFromDestination(idSociete: number, codeCa1: string,  destination: NTHDestination): Observable<SsFamilleModel[]> {
    // tslint:disable-next-line: max-line-length
    return this.http.get<SsFamilleModel[]>(APICONSTANTS.URLAPI.value + this.route + 'getFromDestination?idSociete=' + idSociete  + '&codeCa1=' + codeCa1 + '&destination=' + destination)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }
}
